import { COLORS } from 'Components/utils/color/colors';

const defaultTheme = {
  thCta: 'font-bold underline',
  thCtaDefaultColor: COLORS.BLACK,
};

export const themes = {
  default: defaultTheme,
  thumbnail: defaultTheme,
};
